export const paymentCardHiddenNumber = (last4) => `**** **** **** ${last4}`

export const paymentCardFormatExpiryDate = (month, year) => {
  return ('0' + month).slice(-2) + '/' + year.toString().slice(-2)
}

export const paymentIbanHiddenNumber = ({ country, bank_code, last4 }) => {
  return `${country}**${bank_code}****${last4}`
}
